var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49998 2.24634H28.4997C29.8847 2.24634 30.9997 3.36133 30.9997 4.74631V21.8788C30.9997 23.2638 29.8847 24.3787 28.4997 24.3787H3.49998C2.11499 24.3787 1 23.2638 1 21.8788V4.74631C1 3.36133 2.11499 2.24634 3.49998 2.24634Z",
    fill: "#F58080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12398 4.677C7.72605 4.677 7.17623 4.97557 7.17623 5.739C7.17623 7.27398 6.39531 7.99631 4.4453 7.99631C3.99123 7.99631 3.48242 8.36839 3.48242 8.91085V17.7161C3.48242 18.2585 3.99123 18.6306 4.4453 18.6306C6.39531 18.6306 7.17623 19.353 7.17623 20.8879C7.17623 21.6514 7.72605 21.9499 8.12398 21.9499H23.8758C24.2737 21.9499 24.8235 21.6514 24.8235 20.8879C24.8235 19.353 25.6044 18.6306 27.5545 18.6306C28.0085 18.6306 28.5173 18.2585 28.5173 17.7161V8.91085C28.5173 8.36839 28.0085 7.99631 27.5545 7.99631C25.6044 7.99631 24.8235 7.27398 24.8235 5.739C24.8235 4.97557 24.2737 4.677 23.8758 4.677H8.12398Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9836 21.5349L12.0011 28.4113C12.0032 29.4222 12.7296 29.9812 13.63 29.6646L15.9997 28.8319L18.3691 29.6646C19.2694 29.9812 19.9958 29.4222 19.9979 28.4113L20.0154 21.5349C20.017 20.7755 11.9821 20.7755 11.9836 21.5349H11.9836Z",
    fill: "#D84243"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 14.968C18.7197 14.968 20.9247 17.173 20.9247 19.893C20.9247 22.613 18.7197 24.818 15.9997 24.818C13.2797 24.818 11.0747 22.613 11.0747 19.893C11.0747 17.173 13.2797 14.968 15.9997 14.968Z",
    fill: "#FBD2D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8049 12.3615C10.1143 12.3622 9.55399 11.8027 9.55371 11.1122C9.55409 10.4216 10.1143 9.86211 10.8049 9.86279H21.1967C21.8866 9.86314 22.4458 10.4223 22.446 11.1122C22.4458 11.802 21.8866 12.3612 21.1967 12.3615H10.8049Z",
    fill: "#D84243"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertification);
export default __webpack_public_path__ + "static/media/certification.12eee0bcf4fa4faa3c9f75f19de46aad.svg";
export { ForwardRef as ReactComponent };